import {
  CancelDialogActions,
  ImageCancelDialogLayout,
  CancelModal,
  CancelDialogMessageLayout,
} from '@Components/shared/dialogs/CancelDialog';
import { useCreateFreebets } from '@Modal/hooks/freebets/useCreateFreebets';

export const CreateFreebetsCancelModalDialog: React.FC = () => {
  const { handleCancelTakeMeBack, showCancelFreebetsForm } = useCreateFreebets();

  return (
    <>
      {showCancelFreebetsForm && (
        <CancelModal open={showCancelFreebetsForm}>
          <ImageCancelDialogLayout
            title="Cancel freebets changes?"
            actions={
              <CancelDialogActions
                onReject={() => handleCancelTakeMeBack('back')}
                onConfirm={() => handleCancelTakeMeBack('')}
              />
            }
          >
            <CancelDialogMessageLayout>
              You are about to delete all the changes you have made in freebets settings
            </CancelDialogMessageLayout>
          </ImageCancelDialogLayout>
        </CancelModal>
      )}
    </>
  );
};
